/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { connect } from 'react-redux';
import { useHistory } from 'react-router'
import { AudioIntroComponent } from '../../components';

const AudioIntroPage = ({ currentSite }) => {
  const history = useHistory();
  const redirectEffect = () => { setTimeout(() => { 
    if(currentSite === "factory"){
      history.replace('/vr/drone/7')
    }else if(currentSite === "wise"){
      history.replace('/vr/showroom/1')
    }else if(currentSite === "wicanders"){
      history.replace('/vr/showroom/1')
    }else{
      history.replace('/splash-split')
    }
  }, 3000) }
  React.useEffect(redirectEffect, [])

  return (
    <AudioIntroComponent />
  )
};

const mapStateToProps = ({ app }) => {
  const { currentSite } = app

  return {
    currentSite
  }
}

export default connect(mapStateToProps, null)(React.memo(AudioIntroPage))